import { createTheme } from '@mui/material/styles';
import { alpha, lighten } from '@mui/material/styles';

import baseTheme from './theme';
import variables from '../variables';

const TEXT_PRIMARY_COLOR = variables.colors.primary;
const TEXT_SECONDARY_COLOR = '#75738b';
const DIVIDER_COLOR = '#E7E2FC';
const BORDER_COLOR = '#F6F6F6';

const lightTheme = createTheme(baseTheme, {
    palette: {
        ...baseTheme.palette,
        primary: {
            main: variables.colors.secondary,
            light: '#818CF8',
            dark: '#4F46E5',
            contrastText: '#ffffff',
        },
        secondary: {
            main: variables.colors.primary,
            light: '#404040',
            dark: '#0a0a0a',
            contrastText: '#ffffff',
        },
        error: {
            main: '#E11D48',
            light: '#F43F5E',
            dark: '#BE123C',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#D97706',
            light: '#F59E0B',
            dark: '#B45309',
            contrastText: '#ffffff',
        },
        info: {
            main: '#0284C7',
            light: '#38BDF8',
            dark: '#0369A1',
            contrastText: '#ffffff',
        },
        success: {
            main: '#059669',
            light: '#10B981',
            dark: '#047857',
            contrastText: '#ffffff',
        },
        action: {
            hover: alpha(variables.colors.secondary, 0.06)
        },
        text: {
            primary: TEXT_PRIMARY_COLOR,
            secondary: TEXT_SECONDARY_COLOR,
        },
        divider: DIVIDER_COLOR
    },
    typography: {
        ...baseTheme.typography,
        fontFamily: "'Plus Jakarta Sans', 'Inter', system-ui, -apple-system, sans-serif",
    },
    shadows: [
        "none",
        "0 1px 15px 1px rgba(0, 0, 0, 0.11)",
        "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
        "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
        "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
        "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
        "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
        "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
        "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
        "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
        "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
        "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
        "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
        "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
        "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
        "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
        "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
        "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
        "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
        "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
        "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
        "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)"
    ],
    components: {
        ...baseTheme.components,
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: BORDER_COLOR,
                    padding: '3px 8px'
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: BORDER_COLOR
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                colorDefault: {
                    '&.MuiChip-outlined': {
                        color: variables.colors.primary + ' !important',
                        borderColor: variables.colors.primary,
                        height: '18px',
                        fontSize: '12px',
                        borderRadius: '6px'
                    }
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    '&.MuiTab-textColorPrimary:not(.Mui-selected)': {
                        color: variables.colors.primary
                    }
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&.MuiTableRow-head': {
                        '& th:first-of-type': {
                            borderTopLeftRadius: '12px'
                        },
                        '& th:last-child': {
                            borderTopRightRadius: '12px'
                        }
                    }
                }
            }
        },
        // MuiAlert: {
        //     styleOverrides: {
        //         root: {
        //             position: 'relative',
        //             overflow: 'hidden',
        //             '& .MuiAlert-icon': {
        //                 // position: 'absolute',
        //                 // right: 0,
        //                 // opacity: '0.2',
        //                 // fontSize: '60px',
        //                 // margin: 0,
        //                 // padding: 0,
        //                 // // TODO
        //                 // // fontSize: '227px',
        //                 // // top: '-95px',
        //                 // // right: '-93px'
        //             }
        //         }
        //     }
        // },
        RaLayout: {
            styleOverrides: {
                root: {
                    backgroundColor: alpha(variables.colors.secondary, 0.025),
                    '& .RaLayout-content': {
                        backgroundColor: 'transparent'
                    },
                    '& .recharts-responsive-container': {
                        '& .recharts-cartesian-grid-horizontal line, &.recharts-cartesian-grid-vertical': {
                            stroke: '#E5E5E5'
                        },
                        '& .recharts-xAxis .recharts-cartesian-axis-line': {
                            stroke: '#E5E5E5'
                        },
                        '& .recharts-cartesian-axis-tick line, & .recharts-yAxis .recharts-cartesian-axis-line': {
                            display: 'none'
                        },
                        '& .recharts-tooltip-cursor': {
                            fill: '#E5E5E5'
                        },
                        '& .recharts-brush-texts': {
                            fontSize: '12px'
                        }
                    },
                    '& .list-page .MuiToolbar-root': {
                        '@media (max-width: 600px)': {
                            justifyContent: 'flex-start',
                            alignItems: 'center'
                        }
                    }
                },
                content: {
                    backgroundColor: 'transparent',
                    marginTop: '15px'
                }
            }
        },
        RaAppBar: {
            styleOverrides: {
                root: {
                    background: variables.colors.primary
                }
            },
        },
        RaMenu: {
            styleOverrides: {
                root: {
                    paddingTop: '10px'
                }
            }
        },
        RaMenuItemLink: {
            styleOverrides: {
                root: {
                    margin: '5px 10px',
                    borderRadius: '200px',
                    color: TEXT_SECONDARY_COLOR,
                    '& .MuiListItemIcon-root': {
                        color: TEXT_SECONDARY_COLOR
                    },
                    '& svg': {
                        color: TEXT_SECONDARY_COLOR
                    },
                    '&:hover': {
                        backgroundColor: alpha(variables.colors.secondary, 0.15),
                        color: variables.colors.secondary,
                        '& .MuiListItemIcon-root': {
                            color: variables.colors.secondary
                        },
                        '& svg': {
                            color: variables.colors.secondary
                        }
                    },
                    '&.RaMenuItemLink-active': {
                        backgroundColor: alpha(variables.colors.secondary, 0.15),
                        color: variables.colors.secondary,
                        '& .MuiListItemIcon-root': {
                            color: variables.colors.secondary
                        },
                        '& svg': {
                            color: variables.colors.secondary
                        }
                    }
                }
            }
        },
        RaBulkActionsToolbar: {
            styleOverrides: {
                root: {
                    padding: '5px',
                    '& .RaBulkActionsToolbar-toolbar': {
                        backgroundColor: lighten(variables.colors.secondary, 0.75),
                        outline: `1px solid ${lighten(variables.colors.secondary, 0.75)}`,
                        height: '68px',
                        top: '-12px',
                        '&.RaBulkActionsToolbar-collapsed': {
                            height: 0,
                            outline: 0
                        }
                    }
                }
            }
        },
        RaCreate: {
            styleOverrides: {
                root: {
                    marginBottom: '15px'
                }
            }
        },
        RaEdit: {
            styleOverrides: {
                root: {
                    marginBottom: '15px'
                }
            }
        },
        RaShow: {
            styleOverrides: {
                root: {
                    marginBottom: '15px'
                }
            }
        },
    }
});

export default lightTheme;
